import React, { createContext, useContext, useMemo } from 'react';
import WidgetSizeContext from '../WidgetSizeContext';
var isArray = function isArray(tbd) {
  return Array.isArray(tbd);
};
var isElement = function isElement(tbd) {
  return typeof tbd.props !== undefined;
};
export var GroupGridGroupsContext = createContext([]);
export default function GroupGridGroupsProvider(_ref) {
  var groupChildren = _ref.groupChildren,
    _ref$isCardView = _ref.isCardView,
    isCardView = _ref$isCardView === void 0 ? false : _ref$isCardView,
    children = _ref.children;
  var widgetSize = useContext(WidgetSizeContext);
  var gridGroups = useMemo(function () {
    var result = [];
    if (isArray(groupChildren)) {
      if (widgetSize === 'small' || isCardView) {
        result.push({
          useGrid: false,
          children: groupChildren
        });
      } else {
        groupChildren.forEach(function (child) {
          if (isElement(child)) {
            var _isArray = child.props.schema && child.props.schema.type === 'array';
            var isGroup = child.props.type === 'group';
            var isText = child.props.type === 'text';
            var showChildInGrid = !_isArray && !isGroup && !isText;
            if (showChildInGrid) {
              if (result.length === 0 || result[result.length - 1].useGrid === false) {
                result.push({
                  useGrid: true,
                  children: []
                });
              }
              result[result.length - 1].children.push(child);
            } else {
              result.push({
                useGrid: false,
                children: [child]
              });
            }
          }
        });
      }
    }
    return result;
  }, [groupChildren, widgetSize]);
  return /*#__PURE__*/React.createElement(GroupGridGroupsContext.Provider, {
    value: gridGroups
  }, children);
}